export default {
    export: 'Exportar',
    'print-material-statement': 'Imprimir estado de artículo',
    'export-as-excel': 'Exportar a excel',
    'material-name-or-num': 'Número o nombre de artículo',
    'from-date': 'De fecha',
    'to-date': 'Hasta fecha',
    'refresh': 'Actualizar',
    'go-to-the-journal-entry': 'Ir al diario de asiento relacionado',
    'final-balance': 'Saldo final:',
    'total-incoming-quantity': 'Cantidad entrante total',
    'total-outcoming-quantity': 'Cantidad saliente total',

    headers: {
        'balance': 'Saldo',
        'income-quantity': 'Cantidad entrante',
        'outcome-quantity': 'Cantidad saliente',
        'count': 'Conteo',
        'note': 'Descripción',
        'date': 'Fecha',
        'price': 'Precio',
        'document-no': 'Ref. Doc.',
        'materials-journal-balance': 'Número de diario de artículo',
        'invoice-balance': 'Número de factura',
        'sequence': 'Serial',
        'account': 'Cuenta',
    }
}